import type { FetchAdditionalPaymentCategoriesListQuery } from '@/features/additional-payment-categories/api'
import type { AdditionalPaymentCategoriesSearch } from '@/routes/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/-models/additional-payment-categories-search'

export function buildFetchAdditionalPaymentCategoriesQuery(
  tenantKey: string,
  deps: AdditionalPaymentCategoriesSearch
): FetchAdditionalPaymentCategoriesListQuery {
  return {
    tenantKey,
    query: {
      ...deps
    }
  }
}
